import React from 'react';
import { getAppContext } from '~/lib/AppContext';

export default function FeedbackPage() {
    const { apiSite, brandName, supportEmail } = getAppContext().config;
    const isBL = getAppContext().isTheme('BinaryLane');
    return (
        <div className="feedbackPage">
            <h3>Welcome to the mPanel 2.0 Early Access</h3>
            <p>{brandName} is pleased to present the next release of our service management portal as early access.</p>
            <p>The new mPanel has been rebuilt from the ground-up and can be interacted with in a variety of ways:</p>
            <ul>
                <li>
                    The new web portal is a modern, scalable implementation suitable for computers, tablets, and mobile
                    phones.
                </li>
                {isBL && (
                    <li>
                        Our new CLI program <b>bl</b> (
                        <a target="_blank" rel="noreferrer" href="https://github.com/binarylane/binarylane-cli">
                            Github download
                        </a>
                        ) provides access to all the same management features from your favourite Linux, macOS, or
                        Windows shell.
                    </li>
                )}
                <li>
                    The {brandName}{' '}
                    <a target="_blank" rel="noreferrer" href={`${apiSite}/reference/openapi.yaml`}>
                        OpenAPI specification document
                    </a>{' '}
                    combined with an{' '}
                    <a target="_blank" rel="noreferrer" href="https://github.com/OpenAPITools/openapi-generator">
                        OpenAPI client library generator
                    </a>{' '}
                    allows integration into your own software.
                </li>
                <li>
                    Powering all these options is the new{' '}
                    <a target="_blank" rel="noreferrer" href={`${apiSite}/reference`}>
                        {brandName} API 2.0
                    </a>
                    , complete with extensive documentation and cut-and-paste examples to get started that require
                    nothing more than a local installation of <b>curl</b> and an{' '}
                    <a href="/api-info">API Access token</a>.
                </li>
            </ul>
            {/*
            <h3>Known Issues</h3>
                    */}

            <h3>Feedback</h3>
            <p>
                Once you have had a chance to try the new mPanel, we would love to get your feedback! Please get in
                touch via
            </p>
            <ul>
                <li>
                    {' '}
                    <a href={`mailto:${supportEmail}`}>{supportEmail}</a> {isBL && <>or</>}
                </li>
                {isBL && (
                    <li>
                        our Discord server at{' '}
                        <a target="_blank" rel="noreferrer" href="https://discord.com/invite/binarylane">
                            https://discord.com/invite/binarylane
                        </a>
                    </li>
                )}
            </ul>
        </div>
    );
}
